'use strict';

const StickyHandler = require('./sticky_handler');

const PURCHASE_CLUSTER_PADDING = 12;

const StickyPurchaseCluster = {
  init(payload, done) {
    const element = document.querySelector(
      '#purchase-cluster > .purchase-cluster-container'
    );
    const container = document.querySelector('.deal-container');
    const topElement = payload.hasAccessHeader
      ? document.querySelector('#quick-access-wrapper')
      : null;
    new StickyHandler(element, container, PURCHASE_CLUSTER_PADDING, topElement);

    done();
  },
};

module.exports = StickyPurchaseCluster;
